<template>
  <div id="app">
    <hero-section/>
    <main role="main">
      <div class="container">
        <invoice-form/>
      </div>
    </main>
    <footer-section/>
  </div>
</template>

<script>
import HeroSection from './components/HeroSection/HeroSection.vue'
import InvoiceForm from './components/InvoiceForm/InvoiceForm.vue'
import FooterSection from './components/FooterSection/FooterSection.vue'

export default {
  name: 'app',
  components: {
    HeroSection,
    InvoiceForm,
    FooterSection
  }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
